import { createApp } from 'vue'
import './style.css'
import "swiper/css/swiper.css";
import App from './App.vue'
import store from './store'
import Getlanguage from './assets/js/Language'
const $imgUrl = 'http://www.perrys.co.jp/wemew/perrys/officalPc';

const app = createApp(App)
app.use(store)

app.config.globalProperties.$Getlanguage = Getlanguage
app.config.globalProperties.$imgUrl = $imgUrl

app.mount('#app')
